import { Component, Input } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'base-image-viewer',
  templateUrl: './base-image-viewer.component.html',
})
export class BaseImageViewerComponent {
  @Input() src: SafeUrl;
}
